import { IAppState } from '@store';
import { createSelector, createAsyncSelector } from '@flux';


const selectAsyncTenantAccount = createAsyncSelector<TenantAccount, IAppState>({
	get: state => state.platform.main.tenantAccount,
	selector: createSelector(
		state => state.platform.main.tenantAccount.item,
		item => item,
	),
});

function selectActiveTariff(state: IAppState) {
	return selectAsyncTenantAccount.selectItem(state).ActiveTariff;
}

function selectTenantID(state: IAppState) {
	return state.shared.context.item?.SessionTenant?.ID || -1;
}

export const mainPlatformSelectorsPack = {
	selectAsyncTenantAccount,
	selectActiveTariff,
	selectTenantID,
};
